module.exports = __webpack_public_path__ + "3429723c2756144ef2d3175b93a5e5f7.png";